import { useContext } from "react";
import { AnitaChatContext } from "../providers/anita-chat-provider";

const UseAnitaChat = () => {
  const chat = useContext(AnitaChatContext);

  return chat;
};

export default UseAnitaChat;
